import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CustomHeaderComponent } from '../custom-header/custom-header.component';
import { EkToastComponent } from '@beta-foundations/ui-kit/messages/toast';
import { MessageService } from 'primeng/api';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-standard-layout',
  standalone: true,
    imports: [ RouterOutlet, CustomHeaderComponent, EkToastComponent ],
  templateUrl: './standard-layout.component.html',
  styleUrl: './standard-layout.component.scss'
})
export class StandardLayoutComponent {

  constructor(private readonly messageService: MessageService, private readonly notificationService: NotificationService) {
    this.notificationService.messageSubject.subscribe((message) => {
      this.messageService.add(message);
    });
  }

}
